import { api } from "../utils/AuthManager";
const GetAllGroups = async () => {
  return api
    .get(`/api/group/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAllGroups;
